const local_time = (): string => {
  let date = new Date().toLocaleString("ja-JP", {timeZone: "Asia/Tokyo", dateStyle: "medium", timeStyle:"medium"})
  return date.replace(/\/+/g, "-")
}

export default local_time
